import React, { createContext, PropsWithChildren, useState } from "react";
import { AppProviderTypes } from "./AppProvider.props";

export const GlobalContext = createContext<AppProviderTypes>([
    {
        showChangeAlert: false,
        disabledItemName: null,
        newOrderTabelRowIndex: 0,
        newOrderTabelCellIndex: 2,
        showNotification: true,
        notificationMessage: "",
        sidebarPref: true,
    },
    () => {},
]);

const AppProvider = React.memo<PropsWithChildren>(({ children }) => {
    const [states, setStates] = useState({
        showChangeAlert: false,
        disabledItemName: null,
        newOrderTabelRowIndex: 0,
        newOrderTabelCellIndex: 2,
        showNotification: true,
        notificationMessage: "",
        sidebarPref: true,
    });

    return (
        <GlobalContext.Provider value={[states, setStates]}>
            {children}
        </GlobalContext.Provider>
    );
});

export default AppProvider;
